import React from 'react';
import styled from 'styled-components';

const ChatOverlayContainerStyled = styled.div`
	qplayer-embed .qplayer-app & {
		bottom: 0;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 20000;
		pointer-events: none;
		overflow: hidden;
		font-size: 16px;

		&.chat-overlay-mobile--hover > div, &.chat-overlay-mobile--hover > button {
			transition: bottom 0.2s linear;
		}
	}
`;

const ChatOverlayWrapperStyled = styled.div`
	qplayer-embed .qplayer-app & {
		height: 100%;
		width: 100%;
		transition: bottom 0.2s linear;
		position: absolute;
		z-index: 2;
		display: flex;
		flex-direction: row;
		pointer-events: none;
		justify-content: space-between;
	}
`;

const ChatWrapperStyled = styled.div`
	qplayer-embed .qplayer-app & {
		width: 85%;
		display: flex;
		flex-direction: column-reverse;
		pointer-events: none;
		position: relative;
		gap: 5px;

		@media screen and (max-width: 992px) and (orientation: landscape) and (hover: none) and (pointer: coarse) {
			width: 30%;
			pointer-events: none;
		}
	}
`;

interface ChatOverlayWrapperProps {
	isMobile?: boolean;
	chatVisible?: boolean;
	showMobileChat?: boolean;
	hideRightControls?: boolean;
	style?: React.CSSProperties;
}

interface ChatWrapperProps {
	showMobileChat?: boolean;
	style?: React.CSSProperties;
}

const ChatOverlayContainer: React.FC<ChatOverlayWrapperProps & React.HTMLAttributes<HTMLDivElement>> = ({
	isMobile: _isMobile,
	chatVisible: _chatVisible,
	showMobileChat: _showMobileChat,
	hideRightControls: _hideRightControls,
	...props
}) => <ChatOverlayContainerStyled {...props} />;

const ChatOverlayWrapper: React.FC<ChatOverlayWrapperProps & React.HTMLAttributes<HTMLDivElement>> = ({
	isMobile,
	chatVisible,
	showMobileChat,
	hideRightControls: _hideRightControls,
	style,
	...props
}) => {
	const inlineStyle: React.CSSProperties = {
		bottom: isMobile ? '0' : '60px',
		visibility: chatVisible ? 'visible' : 'hidden',
		...(chatVisible && !showMobileChat ? { pointerEvents: 'none', background: 'transparent' } : {}),
		...style,
	};
	return <ChatOverlayWrapperStyled style={inlineStyle} {...props} />;
};

const ChatWrapper: React.FC<ChatWrapperProps & React.HTMLAttributes<HTMLDivElement>> = ({
	showMobileChat,
	style,
	...props
}) => {
	const inlineStyle: React.CSSProperties = {
		visibility: showMobileChat ? 'visible' : 'hidden',
		...style,
	};
	return <ChatWrapperStyled style={inlineStyle} {...props} />;
};

export { ChatOverlayContainer, ChatOverlayWrapper, ChatWrapper };
